import {GET, POST} from "@/services/gateway";

const listTeams = ({pagination, search, filter, isGroup}) => {
  return POST('seat/team/list', {pagination, search, filter, isGroup});
}

const listSnapshots = ({teamId, date, dateTo}) => {
  return POST('recovery/team/snapshot/list', {teamId, date, dateTo})
}

const createBackup = (teamId) => {
  return GET('recovery/team/backup', {teamId})
}

const getTeamDetails = (teamId) => {
  return GET('recovery/team/team', {teamId})
}


export {
  listTeams,
  getTeamDetails,
  createBackup,
  listSnapshots
}
